// tslint:disable
export enum ActualType {
    /**
     * @description Standalone Case
     */
    StandaloneCase = 1,
    /**
     * @description Workflow
     */
    Workflow = 2,
    /**
     * @description Workflow Case (sub-case to a Workflow)
     */
    WorkflowCase = 3,
}
(ActualType as any)['STANDALONECASE'] = 1;
(ActualType as any)['WORKFLOW'] = 2;
(ActualType as any)['WORKFLOWCASE'] = 3;
